module.exports = __webpack_public_path__ + "static/media/asteroid.01c5ef5c.png";